import { ModuleWithProviders, NgModule } from '@angular/core'
import { TimeRangeService } from '@ftr/ui-playback'
import { TranscriptFileUploadService } from '../../lib/transcript-upload/transcript-file-upload.service'
import { JobService } from './job.service'

@NgModule({
  providers: [JobService],
})
export class JobServiceModule {
  static forRoot(): ModuleWithProviders<JobServiceModule> {
    return {
      ngModule: JobServiceModule,
      providers: [TranscriptFileUploadService, TimeRangeService],
    }
  }
}
